import router from '@/router';
import CallBuilder from '@/services/call-builder.service';
import { REMOTE_PATHS } from '@/constants/remote-paths.constant';

const state = {
  socket: null,
  conferenceBuilder: new CallBuilder()
};

const getters = {
};

const actions = {
  connectWebsocket({ state, commit, dispatch, rootState }, slotId) {
    if (state.socket) {
      state.socket = null;
    }
    state.socket = new WebSocket(`${REMOTE_PATHS.WS_PATH}/ws?slot_id=${slotId}`);
    state.socket.onopen = () => {
      dispatch('ping');
      dispatch('setPeerConnection');
    };
    state.socket.onmessage = event => {
      state.conferenceBuilder.decodeConnectResponses(event.data).then(decodedData => {
        dispatch('receiveMessage', decodedData);
      });
    };
    state.socket.onclose = event => {
      if (event.code !== 1000) {
        dispatch('closeConference');
        state.socket = null;
      }
    };
  },

  ping({ state, commit, dispatch}) {
    const body = state.conferenceBuilder.createPingBody();
    setTimeout(() => {
      if (state.socket) {
        state.socket.send(body);
        dispatch('ping');
      }
    }, 10000);
  },

  receiveMessage(
    { state, commit, dispatch, rootState },
    response
  ) {
    console.info('message', response.message);
    switch (response.message) {
      case 'updateStatus':
      case 'updateCredentials':
        dispatch('updateConference', response);
        break;
      case 'slotEnded':
        dispatch('closeConference', response.slotEnded.code);
        state.socket.close(1000, 'Deliberate disconnection');
        state.socket = null;
        break;
      case 'webrtcMessage':
        if (
          response.webrtcMessage.data.sessionsDescription
        ) {
          dispatch(
            'setRemoteDescription',
            response.webrtcMessage.data.sessionsDescription
          );
        }
        break;
      case 'adminMutedAllParticipants':
        dispatch(
          'mutedByAdmin',
          response.adminMutedAllParticipants
        );
        break;
      default:
        break;
    }
  },

  sendSocketMessage({ state }, body) {
    if (state.socket) {
      state.socket.send(body);
    }
  }
};

const mutations = {
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/websockets/websocket-connection.js